import { SelectAsync } from '../../components/input/select/main';
import { IClass } from '../../models/components/filters';
import React from 'react';
import Translator from '../../core/i18n';
const T = Translator.create();
export class Class extends React.Component<IClass> {
    public render() {
        return (
            <SelectAsync
                isMulti={true}
                isSearchable={true}
                requestType={'post'}
                parameter={{ CourseIds: this.props.courseIds, SearchedText: '', GetTypes: 'Class', Skip: 0, Take: 5 }}
                placeHolder={T.t('r_gen_filter_class')}
                url={'api/organization/search'}
                closeMenuOnScroll={false}
                closeMenuOnSelect={false}
                name={'selectedClasses'}
                value={this.props.value}
                onChange={this.props.formik.handleChange}
                setFieldValue={this.props.formik.setFieldValue}
                errors={this.props.errors}
                touched={this.props.touched}
                isTouched={this.props.formik.setFieldTouched}
                defaultOptions={false}
                setFieldOnlyValue={true}
                isManualLoading={true}
                className='my-custom-react-select-top'

            />
        );
    }
}